/* import __COLOCATED_TEMPLATE__ from './categories-and-top-topics.hbs'; */
import Component from "@ember/component";
export default Component.extend({
  classNames: ["categories-and-top"],
});
